import React, {useContext} from "react";
import IdentificationFileUpload from "../IdentificationFileUpload";
import IdentificationContext from "../../../context/IdentificationContext";
import {UploadedFile} from "../../../../api-client";
import {CombinedDataContext} from "../../../../hooks/identification/useCombinedData";

const SecondScanUpload = () => {
  const context: CombinedDataContext = useContext(IdentificationContext);

  const loadFiles = (files: Array<UploadedFile>) => {
    context.setSecondPassportScans(files);
  };

  return (
    <IdentificationFileUpload
      prefix="second"
      text="Разворот с регистрацией"
      files={context.secondPassportScans}
      onUploaded={loadFiles}
    />
  );
};

export default SecondScanUpload;